export default __webpack_public_path__ + "static/media/banner_nos-renovamos.90239337.jpg";